import EmptyStateAddSchools from './EmptyStateAddSchools.page';

export default EmptyStateAddSchools;
